import { IconRefresh01 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';

import * as S from './style';

interface IProps {
  bgType?: 'white' | 'black' | undefined;
  setHeight?: number;
  onClick?: () => void;
}

const ComponentRefreshBtn = ({
  bgType = 'white',
  onClick,
  setHeight,
}: IProps) => (
  <S.ComponentRefreshBtn
    className="component-refresh-btn"
    $bgType={bgType}
    onClick={onClick}
    setHeight={setHeight}
  >
    <span className="area-box">
      <span className="icon">
        <IconRefresh01 />
      </span>
      다시 시도하기
    </span>
  </S.ComponentRefreshBtn>
);

export default ComponentRefreshBtn;
